import { Plug } from '../../components/Plug/Plug';
import './CertificatePage.scss';

export const CertificatePage = () => {
  return (
    <section className="gallery">
        <Plug />
    </section>
  );
};